import React, {Component, createRef} from 'react';
import './pScene1.css';
import portraitMp4Home from '../../../Resources/video_home_bg_mobile.mp4'

import {FormattedMessage} from "react-intl";

class PScene1 extends Component<> {
    txtC = createRef();
    componentDidMount() {
        if (this.txtC.current.offsetY < 100) {
            this.forceUpdate();
        }
    }

    render() {
        return (
            <section id={'ps1'} className={'p-container accessibility-img'}>
                <div id="pscene1" className={"p_full-screen clip-all"}>
                    <video className={'p_videobg'} playsInline autoPlay loop muted>
                        <source src={portraitMp4Home} type="video/mp4"/>
                    </video>
                    <h1 id='ps1txt' ref={this.txtC} className={'p-text-container'}>
                        <span className={"p_s1-text"}>
                            <FormattedMessage id={"phome_intro_txt"}/></span>
                        <span className={"p_s1-text"}><FormattedMessage id={"phome_intro_txt_2"}/></span>
                    </h1>
                </div>
            </section>
        )
    }
}

export default PScene1;
